import { FC } from 'react';

import { NavLink, useHistory } from 'react-router-dom';

import {
  IconGroupSvg,
  IconGymSvg,
  IconPieChartSvg,
  IconSettingsSvg,
} from '~/assets/icons';
import { ImageLogoHeaderPng, ImageLogoAtomBlack } from '~/assets/images';

import { Container } from './styles';

interface SidebarProps {
  sidebarIsVisible: boolean;
}

const Sidebar: FC<SidebarProps> = ({ sidebarIsVisible }) => {
  const { push } = useHistory();

  return (
    <Container visible={sidebarIsVisible}>
      <header>
        <img src={ImageLogoHeaderPng} alt="" />

        <h1>Intelligent Business</h1>
      </header>

      <NavLink to="/professional/students">
        <section>
          <IconGroupSvg />
          <p>Meus Alunos</p>
        </section>
      </NavLink>

      <NavLink to="/professional/manager">
        <section>
          <IconGymSvg />
          <p>I.Manager</p>
        </section>
      </NavLink>

      <NavLink to="/professional/manager-report">
        <section>
          <IconPieChartSvg />
          <p>I.Boss</p>
        </section>
      </NavLink>

      <NavLink to="/professional/settings">
        <section>
          <IconSettingsSvg />
          <p>Configurações</p>
        </section>
      </NavLink>

      <button type="button" onClick={() => push('/professional/lab')}>
        <ImageLogoAtomBlack />
        <p>I.LAB</p>
      </button>
    </Container>
  );
};

export default Sidebar;
